import { useQuery } from "@tanstack/react-query";
import { fetchTopSales } from "./api/products";

export const useGetTopSales = () => {
  return useQuery({
    queryKey: ["topSales"],
    queryFn: () => fetchTopSales(),
  });
};
